import { CommonModule } from "@angular/common";
import { Component, OnInit, inject, AfterViewInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Observable } from "rxjs";

import { PlatformService } from "../../core";
import { fadeInUpAnimation } from "../../shared/animations";
import { OfferCardsComponent } from "./components/offer-cards";
import { PricingTableComponent } from "./components/pricing-table";
import { InstagramFeedComponent } from "./components/instagram-feed";
import { fadeInDownAnimation } from "../../shared/animations/fade-in-down.animation";
import { ChiSiamoComponent } from "../chi-siamo/chi-siamo.component";
import { ContattiComponent } from "../contatti/contatti.component";

@Component({
    selector: 'app-home',
    standalone: true,
    imports: [CommonModule, OfferCardsComponent, PricingTableComponent, InstagramFeedComponent, ChiSiamoComponent, ContattiComponent],
    animations: [fadeInUpAnimation, fadeInDownAnimation],
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
  })
  export class HomeComponent implements OnInit, AfterViewInit {
    private router = inject(Router);
    private route = inject(ActivatedRoute);
    private platformService = inject(PlatformService);

    isAuthenticated$: Observable<boolean>;

    constructor() {
      this.isAuthenticated$ = this.platformService.getAuthStatus$();
    }

    ngOnInit(): void {
      // La homepage è accessibile a tutti, non reindirizza più
      // L'autenticazione viene gestita solo per mostrare contenuti diversi
    }

    ngAfterViewInit(): void {
      // Gestisce lo scroll al fragment dopo che la vista è stata inizializzata
      if (this.platformService.isBrowser()) {
        this.route.fragment.subscribe(fragment => {
          if (fragment) {
            setTimeout(() => {
              const element = document.getElementById(fragment);
              if (element) {
                const headerOffset = 80; // Altezza dell'header fisso + margine
                const elementPosition = element.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                window.scrollTo({
                  top: offsetPosition,
                  behavior: 'smooth'
                });
              }
            }, 100);
          }
        });
      }
    }

    goToLogin(): void {
      if (this.platformService.isBrowser()) {
        this.router.navigate(['/login']);
      }
    }
  }